import b from 'b_';
import isEqual from 'lodash/isEqual';
import PropTypes from 'prop-types';
import React from 'react';

import Checkbox from '../checkbox/checkbox';
import Text from '../text/text';

import { attributeFilterPropType } from './utils';

const BOOL_FILTER_VALUE = 1;

class AttributeFilterTypeBool extends React.Component {
    static propTypes = {
        available: attributeFilterPropType,
        filter: attributeFilterPropType,
        onChange: PropTypes.func.isRequired,
        value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    };

    handleChange = ({ target: { checked } }) => {
        const { onChange } = this.props;

        onChange(checked ? BOOL_FILTER_VALUE : undefined);
    };

    getIsChecked = () => {
        const { value } = this.props;

        return Number(value) === BOOL_FILTER_VALUE;
    };

    render() {
        const { available, filter } = this.props;
        const checked = this.getIsChecked();
        const disabled = !available && !checked;

        return (
            <div className={b('attribute', 'filter', { type: 'bool' })}>
                <Checkbox checked={checked} disabled={disabled} onChange={this.handleChange}>
                    <Text weight={Text.WEIGHT.M}>{filter.name}</Text>
                </Checkbox>
            </div>
        );
    }
}

export default React.memo(AttributeFilterTypeBool, (prevProps, nextProps) => {
    return isEqual(prevProps.available, nextProps.available) && isEqual(prevProps.filter, nextProps.filter);
});
